import {
  asLoadRef,
  vBoolStrict,
  vNonEmptyString,
  vObject,
  vObjectId,
  vOptional,
  type vOutput,
} from '../validation/index.ts'
import type { ProcessStatus } from './process-status.ts'

export const bolNumberAvailabilityQuerySchema = vObject({
  bolNumber: vNonEmptyString(),
  loadId: asLoadRef(vOptional(vObjectId())),
})

export type BolNumberAvailabilityQuery = vOutput<
  typeof bolNumberAvailabilityQuerySchema
>

export const bolNumberAvailabilityResponseSchema = vObject({
  isUsed: vBoolStrict(),
})

export type BolNumberAvailabilityResponse = vOutput<
  typeof bolNumberAvailabilityResponseSchema
>

export interface LoadBOLDetail {
  status: ProcessStatus
  error?: string
  errorType?: string
  bolNumber?: string
  childBolNumbers?: string[]
  timeoutDate?: Date
  changedAfterDispatch?: boolean
}
